module.exports = __webpack_public_path__ + "34746a53f50ccc546434e81a63e4b2d6.png";